import React from 'react';

import {CircularProgress,  Stack} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import AudioPlayer from "../Communication/AudioPlayer";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";


class MessageAudio extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            content: null,
            load: false,
        }
    }

    async componentDidMount() {
    }

    async retrieveContent(){
        const url = `message/${this.props.message.id}/download`;
        const api = new BaseApi();
        let params = {};
        let response = await api.get(
            url,
            params
        );
        this.setState({
            content: response.data.content
        })
    }

    async retrieveMediaText(){
        const url = `message/${this.props.message.id}/media_text/`;
        const api = new BaseApi();
        let params = {};
        let response = await api.get(
            url,
            params
        );
        this.setState({
            textContent: response.data.content
        })
    }

    render() {
        if (!this.state.load) {
            return (
                <Stack
                    spacing={1}
                >
                    <Typography>
                        {this.props.message.uploadname}
                    </Typography>
                    <Button
                        onClick={this.retrieveContent.bind(this)}
                    >
                        Загрузить аудио
                    </Button>
                    <Button
                        size={'sm'}
                        onClick={this.retrieveMediaText.bind(this)}
                    >
                        Распознать
                    </Button>
                </Stack>
            )
        }
        if (this.state.load && !this.state.content) {
            return (
                <CircularProgress/>
            )
        }
        return (
            <Stack
                sx={{
                    width: '100%'
            }}
            >
                <Typography>
                    {this.props.message.uploadname}
                </Typography>
                <Stack
                    direction={'row'}
                    spacing={1}
                    sx={{
                        flexWrap: 'wrap',
                    }}
                    alignItems={'center'}
                >
                    <AudioPlayer
                        base64String={this.state.content}
                        extension={this.props.message.extension}
                    />
                    <Button
                        size={'sm'}
                        onClick={this.retrieveMediaText.bind(this)}
                    >
                        Распознать
                    </Button>
                </Stack>
                {
                    this.state.textContent?
                        <Typography>
                            {this.state.textContent}
                        </Typography>:
                        null
                }
            </Stack>
        )
    }
}

export default MessageAudio
